/*
 * @Description
 * @Version: 2.0
 * @Autor: whaoo
 * @Date: 2023-10-10 09:26:28
 * @LastEditors: whaoo
 * @LastEditTime: 2024-06-21 09:04:17
 */
import Vue from 'vue'
import Router from 'vue-router'
import BedList from '@/view/bed_list'
import BedDetail from '@/view/bed_detail'
import BindDevice from '@/view/bind_device'
import DeviceData from '@/view/device_data'
import device_list from '@/view/managePages/device_list'
import all_device_data from '@/view/managePages/all_device_data'
import all_device_data_1 from '@/view/managePages/all_device_data_1'
import login from '@/view/layout/login'
import layout from '@/view/layout/layout'
import device_manage from '@/view/managePages/device_manage'
import sleep_report from '@/view/managePages/sleep_report'
import activity_report from '@/view/managePages/activity_report'
import device_log from '@/view/managePages/device_log'
import huanz_list from '../view/managePages/huanz_list.vue'
import activity_statics from '../view/managePages/activity_statics.vue'
import gateway_administration from '../view/managePages/gateway_administration.vue'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/bedList',
      name: 'bedList',
      component: BedList
    }, {
      path: '/bedDetail',
      name: 'bedDetail',
      component: BedDetail,
    },
    {
      path: "/bindDevice",
      name: 'bindDevice',
      component: BindDevice
    },
    {
      path: "/deviceData",
      name: 'deviceData',
      component: DeviceData
    }
    // ,
    // {
    //   path: "/device_list",
    //   name: 'device_list',
    //   component: device_list
    // }
    // ,
    // {
    //   path: "/all_device_data",
    //   name: 'all_device_data',
    //   component: all_device_data
    // }
    ,
    {
      path: "/login",
      name: 'login',
      component: login
    },
    {
      path:"/layout",
      name:"layout",
      component:layout,
      children:[
        {
          path: "/all_device_data",
          name: 'all_device_data',
          component: all_device_data
        } ,
        {
          path: "/device_list",
          name: 'device_list',
          component: device_list
        },
        {
          path: "/device_manage",
          name: 'device_manage',
          component: device_manage
        },
        {
          path: "/huanz_list",
          name: 'huanz_list',
          component: huanz_list
        },
        {
          path: "/sleep_report",
          name: 'sleep_report',
          component: sleep_report
        },
        {
          path: "/activity_report",
          name: 'activity_report',
          component: activity_report
        },
        {
          path: "/device_log",
          name: 'device_log',
          component: device_log
        },
        {
          path: "/activity_statics",
          name: 'activity_statics',
          component: activity_statics
        },
        {
          path: "/gateway_administration",
          name: 'gateway_administration',
          component: gateway_administration
        }

        
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js